export default __webpack_public_path__ + "static/media/roundedCrossDark.6fab36f0.svg";